import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-project-nums",
  "use": "icon-project-nums-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-project-nums\">\r\n<path d=\"M199.9,174.8V49.2c0-15.1-13.9-14-13.9-14h-78.5c-4.5,0-7.2-2.2-7.2-2.2s-3.3-5.6-9.5-14.5c-5.6-10.1-12.8-8.4-12.8-8.4\r\n\tH17.3C0,10.1,0,26.3,0,26.3v147.4c0,18.4,13.9,16.2,13.9,16.2h173.7C202.1,189.9,199.9,174.8,199.9,174.8z M50.7,143\r\n\tc-6.1,0-10.6-4.5-10.6-10.6c0-6.1,4.5-10.6,10.6-10.6s10.6,5,10.6,10.6S56.8,143,50.7,143z M50.7,103.4c-6.1,0-10.6-4.5-10.6-10.6\r\n\tc0-5.6,4.5-10.6,10.6-10.6s10.6,5,10.6,10.6S56.8,103.4,50.7,103.4z M154.2,142.4H87.4c-5.6,0-10-4.5-10-10.1s4.5-10.1,10-10.1h66.8\r\n\tc5.6,0,10,4.5,10,10.1S159.8,142.4,154.2,142.4z M154.2,102.8H87.4c-5.6,0-10-4.5-10-10.1s4.5-10.1,10-10.1h66.8\r\n\tc5.6,0,10,4.5,10,10.1S159.8,102.8,154.2,102.8z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/home/project-nums.svg
// module id = qWNG
// module chunks = 13